export const scheduleItems = [
  {
    id: 1,
    title: "Search Property, us, we, our",
    content: "means Search Property Pty Ltd (ACN 638 601 582) of Suite 1, Level 4, 4 Drake Avenue Macquarie Park NSW 2113 and holding licence numbers 10094435 under the Property and Stock Agents Act 2002 (NSW)."
  },
  {
    id: 2,
    title: "Agent",
    content: "means Ravi Sharma holding licence numbers 20273944 under the Property and Stock Agents Act 2002 (NSW)\n\nEmail: ravi@searchproperty.com.au\n\nPhone: 1300 782 692"
  },
  {
    id: 3,
    title: "Buyer, you, your,",
    content: "means the following person(s):\n\nName: [BUYER_NAME]\n\nAddress: [BUYER_ADDRESS]\n\nEmail: [BUYER_EMAIL]\n\nPhone number: [BUYER_PHONE]"
  },
  {
    id: 4,
    title: "Retainer",
    content: "means the sum of $2,500 (inclusive of GST)"
  },
  {
    id: 5,
    title: "Success Fee",
    content: "means the sum of $6,300 (inclusive of GST)"
  },
  {
    id: 6,
    title: "Price Limit",
    content: "means the following price that you have nominated as the maximum purchase price for a property that we source for you:\n\n[PRICE_LIMIT]"
  },
  {
    id: 8,
    title: "Property",
    content: "means any real property within the Price Limit and Property Details sourced by Search Property and presented to you under this Agreement."
  },
  {
    id: 9,
    title: "Approved Acquisition",
    content: "means the Property that you elect to purchase with such election made in writing to Search Property or the Agent or a representative of either Search Property and / or the Agent."
  },
  {
    id: 10,
    title: "Term",
    content: "means the period of commencing from the date that this Agreement is signed by you and ends on the earlier of:\n\ni. 12 months from that date; or\n\nii. the Settlement Date."
  },
  {
    id: 11,
    title: "Services",
    content: "means all work that we conduct for and on your behalf under this Agreement, including but not limited to the following:\n\ni. identify, evaluate and share with you data, information and details about Properties that fit the Property Details;\n\nii. discuss each Property with you and answer any questions you have;\n\niii. repeat steps (i) and (ii) until the Buyer is prepared to proceed with purchasing one of the Properties;\n\niv. negotiate sale price with the sales agent / vendor of the Property;\n\nv. assist the Buyer in engaging, briefing and co-ordinating third parties for purchase and settlement of the Property;\n\nvi. liaise with your third party representatives (e.g. conveyancer, mortgage broker, insurance broker) to ensure that the settlement process is as seamless as possible."
  },
  {
    id: 12,
    title: "Sale Contract",
    content: "means a contract for the purchase of the Approved Acquisition entered into by you and the seller of the Approved Acquisition."
  },
  {
    id: 13,
    title: "Settlement Date",
    content: "means that date on which a Sale Contract is completed and title in the Approved Acquisition passes to you."
  },
  {
    id: 14,
    title: "Confidential Information",
    content: "means information disclosed or otherwise made available to you by us, for or in connection with the Services, that is marked or otherwise identified as being confidential or commercially sensitive (for example, information about the Properties created by us and that is not publicly available)."
  }
];

export const termsAndConditions = [
  {
    title: "1. Interpretation and Definitions",
    content: [
      "In this Agreement:",
      "1.1. capitalised terms are defined in accordance with the Schedule;",
      "1.2. where a party to this Agreement comprises of two or more persons, the rights and obligations of those persons pursuant to this Agreement will apply to each of them jointly and severally; and",
      "1.3. all amounts referred to in this Agreement are in Australian Dollars."
    ]
  },
  {
    title: "2. Acknowledgements, Warranties and Agreements",
    content: [
      "2.1. The Agreement comprises these Terms and Conditions and the Schedule.",
      "2.2. The Buyer warrants, acknowledges and agrees that:",
      "2.2.1. they have authority to enter into this Agreement and by signing the Agreement, they agree to be bound by the terms of the Agreement;",
      "2.2.2. they have or will obtain finance pre-approval from an authorised credit provider for an amount sufficient to fund the Price Limit and such approval will remain valid during the Term;",
      "2.2.3. they have been given the opportunity to obtain independent advice with respect to this Agreement;",
      "2.2.4. they have been given the opportunity to and will seek, at their discretion, independent legal, financial, investment, tax and other professional advice in relation to the purchase of a Property and / or the Approved Acquisition;",
      "2.2.5. they accept full responsibility for purchasing the Approved Acquisition or entering into any Sale Contract;",
      "2.2.6. there is no certainty or guarantees made by Search Property as to returns, gains, yield, profits or revenue in respect of any Properties;",
      "2.2.7. any data, property or strategy information presented by Search Property is general in nature only and does not take into account the Buyer's individual circumstances or their objectives, financial situation or needs. The Services do not constitute financial or investment advice nor should they be relied upon as such. The Buyer acknowledges that Search Property does not hold a financial services license as defined in the Corporations Act 2001 (Cth) and is not authorised to provide financial services to the Client;",
      "2.2.8. any advice given by Search Property to you is general in nature and does not take into account your personal circumstances or objectives, financial situation or needs;",
      "2.2.9. you should assess the suitability of an investment in any Property in light of the your own needs and circumstances, which you can do personally, or by consulting an appropriately licensed financial adviser;",
      "2.2.10. they will notify Search Property in writing of any amendments to their personal details, Property Details, Price Limit or any other matters relating to their proposed purchase of the Approved Acquisition; and",
      "2.2.11. they must provide any information, documents and cooperation reasonably required by Search Property to complete identity verification, source of funds checks, source of wealth checks and any other due diligence required under anti-money laundering and counter-terrorism financing laws, including in relation to any directors, trustees, beneficiaries, beneficial owners, controllers or other individuals associated with the purchasing entity;",
      "2.2.12. Search Property may suspend or terminate this Agreement if the Buyer does not provide such information, documents or cooperation within a reasonable time, or if Search Property is unable to complete its due diligence requirements; and",
      "2.2.13. if this Agreement is suspended or terminated under clause 2.2.12, any fees already paid may be non-refundable in accordance with clause 6, this Agreement and applicable law; and",
      "2.2.14. they will not purchase any property which was presented by Search Property pursuant to this Agreement during the Term, whether verbally or in writing (including without limitation properties presented to the Buyer in person, by telephone, by email, by letter, by fax or by text message), other than through Search Property."
    ]
  },
  {
    title: "3. Appointment and Exclusivity",
    content: [
      "3.1. The Buyer exclusively appoints and authorises the Agent to provide the Services for the duration of the Term.",
      "3.2. This Agreement will:",
      "3.2.1. commence from the date on which all parties have signed this Agreement and Search Property provides you with a fully executed copy of the Agreement; and",
      "3.2.2. continue for the Term, unless validly terminated in accordance with clause 7.",
      "3.3. The Parties may agree to extend the Term at any time. Such agreement must be in writing and may be (but need not be) in the form of email.",
      "3.4. The Buyer acknowledges that this is an exclusive agreement. The Buyer cannot appoint another agent unless this Agreement has expired or been validly terminated in accordance with clause 7.",
      "3.5. The Buyer warrants that it is not subject to any earlier or concurrent agency agreement which would conflict with its obligations under this Agreement."
    ]
  },
  {
    title: "4. Buying Process & Agent's Obligations",
    content: [
      "4.1. Search Property will provide the Services.",
      "4.2. You may at any time authorise Search Property to engage and liaise with your third party representatives (e.g. conveyancer, mortgage broker, insurance broker). Where you do so, Search Property will engage and liaise with those third parties on your behalf but any instructions required by the third parties will need to be confirmed by you.",
      "4.3. Search Property Pty Ltd may recommend third parties to you (including without limitation conveyancers, solicitors, mortgage brokers, building and/or pest inspection companies, strata searching companies, valuers and surveyors) in relation to the purchase of the Approved Acquisition. The Client acknowledges that third parties are independent of Search Property and under no circumstances will Search Property be liable for the advice, acts, or omissions of such third parties.",
      "4.4. In the event that Search Property engages any such third parties on your behalf (which it will only do with your authorisation), you agree to advance the funds to Search Property or reimburse the costs of such to Search Property upon receipt of an invoice."
    ]
  },
  {
    title: "5. Payment",
    content: [
      "5.1. The Buyer must pay the Retainer at the time of signing this Agreement. Search Property will not undertake any Services until the Retainer is paid.",
      "5.2. The Success Fee is only payable on settlement of the Property. Search Property will issue an invoice for payment of the Success Fee at the time of settlement of the Property and the Success Fee must be paid within 7 days of the invoice date."
    ]
  },
  {
    title: "6. Refunds",
    content: [
      "6.1. The Retainer is immediately due and payable to Search Property on the date that this Agreement is executed by you and, subject to clause 6.2, is not refundable under any circumstances.",
      "6.2. Search Property may, in its absolute discretion, elect to refund the Retainer but is under no obligation to do so.",
      "6.3. The Success Fee is not refundable under any circumstances."
    ]
  },
  {
    title: "7. Termination",
    content: [
      "7.1. Search Property may, in its absolute discretion, immediately terminate this Agreement without notice if the Buyer:",
      "7.1.1. engages, appoints, consults with, or accepts the services of another buyers agency in Australia other than Search Property during the Term;",
      "7.1.2. fails to pay the Retainer; and",
      "7.1.3. fails to provide any information, documents or cooperation reasonably required by Search Property to complete its identity verification, source of funds checks, source of wealth checks or other anti-money laundering and counter-terrorism financing due diligence requirements.",
      "7.2. Other than in the circumstances set out in clause 7.1, neither party may terminate this Agreement during the Term.",
      "7.3. At or after the expiry of the Term, either party may terminate this Agreement by giving 14 days written notice to the other party."
    ]
  },
  {
    title: "8. Liability and Indemnities",
    content: [
      "8.1. The Buyer will hold and keep indemnified the Agent against all actions, suits, proceedings, claims, demands, costs, and expenses whatsoever which may be taken or made against the Agent arising out of or in respect of any of the powers, duties or authorities of the Agent under this Agreement.",
      "8.2. The Buyer indemnifies the Agent for all expenses, costs, including but not limited to debt collection fees and/or legal costs and disbursements incurred by the Agent in recovering any outstanding fees under this Agreement.",
      "8.3. The Agent makes no warranties to any information or data from any third parties and expressly disclaims all liability in relation to such information or data, including but not limited to its accuracy, completeness, suitability or reliability.",
      "8.4. Any Claim made by the Client and/or the Guarantor(s) against Search Property or the Agent is limited to the maximum amount of the sum of the Retainer and the Success Fee."
    ]
  },
  {
    title: "9. Confidential Information",
    content: [
      "9.1. For a period of 2 years from the date of this Agreement, the Buyer must:",
      "9.1.1. keep the Confidential Information absolutely confidential at all times;",
      "9.1.2. not use any of the Confidential Information except for the purposes of supporting Search Property to provide the Services."
    ]
  },
  {
    title: "10. General",
    content: [
      "10.1. Waiver",
      "Any failure or delay to exercise or enforce any right under this Agreement or partial exercise or enforcement of any right under this Agreement is not a waiver of that right or any other right provided by law.",
      "10.2. Governing Law",
      "This Agreement will be governed by and interpreted in accordance with the laws of New South Wales."
    ]
  },
  {
    title: "11. Correspondence",
    content: [
      "11.1. Correspondence",
      "All correspondence and amendments made via email will be valid throughout this Agreement."
    ]
  }
];
